/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_lodash@4.17.20@lodash/_freeGlobal.js
// module id = 131
// module chunks = 0